document.addEventListener("DOMContentLoaded", function () {
  // Select all buttons and content containers
  const buttons = document.querySelectorAll(".information-menu-item");
  const contents = document.querySelectorAll(".information-content-container");
  const menuContainer = document.querySelector(".information-menu-container");
  const contentWrapper = document.querySelector(".information-content-wrapper");

  // Function to show a specific section
  function showSection(sectionId) {
    // Remove 'active' class from all buttons and hide all content containers
    buttons.forEach((button) => button.classList.remove("active"));
    contents.forEach((content) => {
      content.classList.add("hidden");
      content.classList.remove("active-content");
    });

    // Find and activate the button for this section
    const buttonId = sectionId + "-button";
    const button = document.getElementById(buttonId);
    if (button) {
      button.classList.add("active");
      button.style.opacity = "0.4";
    }

    // Show the corresponding content container
    const contentToShow = document.getElementById(sectionId);
    if (contentToShow) {
      contentToShow.classList.remove("hidden");
      contentToShow.classList.add("active-content");
    }
  }

  // Function to handle button clicks and toggle visibility
  function handleButtonClick(event) {
    // Skip the contact button from the rest of the logic
    if (event.target.id === "contact-button") {
      // Trigger the same effect as handleMouseLeave when contact-button is clicked
      handleMouseLeave({ target: event.target }); // Simulate mouse leave effect
      return; // Skip other logic for the contact-button
    }

    // Get the section name from the button ID
    const contentId = event.target.id.replace("-button", "");

    // Update the URL with the section
    const newUrl = window.location.pathname + "#" + contentId;
    history.pushState({ section: contentId }, "", newUrl);

    // Show the selected section
    showSection(contentId);
  }

  // Function to handle mouse enter for a specific button
  function handleMouseEnter(event) {
    const hoveredButton = event.target;
    const activeButton = document.querySelector(
      ".information-menu-item.active"
    );

    // If the hovered button is the active button, set its opacity to 1
    if (activeButton && activeButton === hoveredButton) {
      hoveredButton.style.opacity = "1";
    } else {
      hoveredButton.style.opacity = "0.4";

      // Ensure the active button has full opacity while hovering over other buttons
      if (activeButton) {
        activeButton.style.opacity = "1";
      }
    }
  }

  // Function to handle mouse leave for a specific button
  function handleMouseLeave(event) {
    const hoveredButton = event.target;
    const activeButton = document.querySelector(
      ".information-menu-item.active"
    );

    if (activeButton && activeButton === hoveredButton) {
      hoveredButton.style.opacity = "0.4";
    } else if (activeButton) {
      activeButton.style.opacity = "0.4";
    }

    // Reset the hovered button to full opacity if it was not active
    if (!hoveredButton.classList.contains("active")) {
      hoveredButton.style.opacity = "1";
    }
  }

  // Add click and hover event listeners to each button
  buttons.forEach((button) => {
    button.addEventListener("click", handleButtonClick);
    button.addEventListener("mouseenter", handleMouseEnter);
    button.addEventListener("mouseleave", handleMouseLeave);
  });

  // Handle browser back/forward buttons
  window.addEventListener("popstate", function (event) {
    if (event.state && event.state.section) {
      showSection(event.state.section);
    } else {
      // If no state, check the hash in URL
      const hash = window.location.hash.substring(1);
      if (hash) {
        showSection(hash);
      } else {
        showSection("biography");
      }
    }
  });

  // Initial state setup: Check URL for section on page load
  const hash = window.location.hash.substring(1); // Get hash without the '#'
  if (hash && document.getElementById(hash)) {
    // Show the section from the URL hash
    showSection(hash);
    // Update history state
    history.replaceState({ section: hash }, "", window.location.href);
  } else {
    // Default to biography if no valid hash
    showSection("biography");
    history.replaceState(
      { section: "biography" },
      "",
      window.location.pathname + "#biography"
    );
  }
});
